export function renderMarkdown(src: string): string {
  // escape HTML entities first (XSS protection)
  const esc = src
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
  return esc
    .replace(/`([^`]+)`/g, '<code class="md-code">$1</code>')
    .replace(/\[([^\]]+)\]\((https?:\/\/[^)\s]+)\)/g, '<a class="md-link" href="$2" target="_blank" rel="noopener noreferrer">$1</a>')
    .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
    .replace(/\*([^*]+)\*/g, '<em>$1</em>')
    .replace(/^[-•]\s+(.*)$/gm, '<li>$1</li>')
    .replace(/\n/g, '<br />')
}

// Replace text nodes only (skips content inside <code> and <a> tags)
function replaceOutsideHtml(
  html: string,
  pattern: RegExp,
  replacer: (match: string, g1: string) => string,
): string {
  const parts = html.split(/(<[^>]+>)/)
  let depth = 0
  return parts
    .map((part, i) => {
      if (i % 2 === 1) {
        if (/^<(code|a)[\s>]/i.test(part)) depth++
        if (/^<\/(code|a)>/i.test(part)) depth--
        return part
      }
      return depth > 0 ? part : part.replace(pattern, replacer)
    })
    .join('')
}

const TAG_RENDER_RE = /#([a-zA-ZЀ-ӿא-ת0-9_]+)/g

export function replaceHashtags(html: string): string {
  return replaceOutsideHtml(html, TAG_RENDER_RE, (_, tag) => {
    const lower = tag.toLowerCase()
    return `<a class="md-tag" data-tag="${lower}" href="/?tag=${lower}">#${tag}</a>`
  })
}

const MENTION_RENDER_RE = /(?<![a-zA-Z0-9_.])@([a-zA-Z0-9_]+)/g

export function replaceMentions(html: string): string {
  return replaceOutsideHtml(html, MENTION_RENDER_RE, (_, username) => {
    const lower = username.toLowerCase()
    return `<a class="md-mention" data-username="${lower}" href="/@${lower}">@${username}</a>`
  })
}

const URL_AUTOLINK_RE = /(https?:\/\/[^\s<>"{}|\\^`[\]]+)/g

export function autoLinkUrls(html: string): string {
  return replaceOutsideHtml(html, URL_AUTOLINK_RE, (_, rawUrl) => {
    const url = rawUrl.replace(/[.,!?;:)}\]]+$/, '')
    const suffix = rawUrl.slice(url.length)
    return `<a class="md-link" href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>${suffix}`
  })
}
